import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { MarkdownModePluginState } from '../markdownModePluginType';

export const markdownModePluginKey: PluginKey<MarkdownModePluginState> =
	new PluginKey<MarkdownModePluginState>('markdownMode');
